import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Users, Package, Boxes, ShoppingBag, LifeBuoy, Ticket,
  Mail, MessageSquare, LogOut, Beaker, ArrowLeft, Truck, MailPlus, BookOpen, Award
} from "lucide-react";

const links = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/inventory", label: "Inventory", icon: Boxes },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/affiliates", label: "Affiliates", icon: Award },
  { to: "/admin/research", label: "Research Hub", icon: BookOpen },
  { to: "/admin/tickets", label: "Tickets", icon: LifeBuoy },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket },
  { to: "/admin/shipping", label: "Shipping", icon: Truck },
  { to: "/admin/email-templates", label: "Email Templates", icon: MailPlus },
  { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
  { to: "/admin/contact-messages", label: "Contact Messages", icon: MessageSquare },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-8 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group">
            <img src="/logo.webp" alt="" className="h-9 w-9 object-contain -my-1"/>
            <div className="font-display text-sm font-semibold text-[#0e2f6b]">Peps<span className="text-blue-500">4</span>Pets</div>
            <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500 border-l border-slate-300 pl-2 ml-1">Admin</span>
          </Link>
          <div className="flex items-center gap-3 text-sm">
            <Link to="/" className="text-slate-500 hover:text-slate-900 inline-flex items-center gap-1"><ArrowLeft className="w-4 h-4" strokeWidth={1.75}/> Back to site</Link>
            <span className="text-slate-300">·</span>
            <span className="text-slate-600">{user?.email}</span>
            <button
              onClick={async () => { await logout(); navigate("/"); }}
              className="text-red-600 hover:text-red-700 inline-flex items-center gap-1"
              data-testid="admin-logout"
            >
              <LogOut className="w-4 h-4" strokeWidth={1.75}/> Sign out
            </button>
          </div>
        </div>
      </header>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-8 grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-8">
        <aside className="lg:sticky lg:top-20 lg:self-start">
          <nav className="border border-slate-200 rounded-md p-2 bg-white" data-testid="admin-sidebar">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                data-testid={`admin-sidebar-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 px-3 py-2 rounded-md text-sm transition-colors ${
                    isActive ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-50"
                  }`
                }
              >
                <l.icon className="w-4 h-4" strokeWidth={1.75} /> {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <div className="min-w-0"><Outlet /></div>
      </div>
    </div>
  );
}
